import { createSelector } from 'reselect';
import PlaySequence from '@gameday/utils/PlaySequence';
import { getEnableDFVMobile } from './getDynamicFieldView';

// selectors
const getDynamicFieldViewLive = (state) => state?.dynamicFieldViewLive;
const getAllPlays = (state) => getDynamicFieldViewLive(state)?.allPlays;
const getCurrentPlay = (state) => getDynamicFieldViewLive(state)?.currentPlay;
const getGamePk = (state) => getDynamicFieldViewLive(state)?.gamePk;
const getIsSameGame = (state) => getDynamicFieldViewLive(state)?.isSameGame;
const getVenue = (state) => state.gumbo?.gameData?.venue;
const getVenueId = (state) => getVenue(state)?.id;
const getDFVPlay = (state) => state.config?.dfvPlay;

let playSequenceInstance = null;

export const getDynamicFieldViewLiveState = createSelector(
    [getAllPlays, getCurrentPlay, getGamePk, getIsSameGame, getDFVPlay, getEnableDFVMobile, getVenueId],
    (allPlays, currentPlay, gamePk, isSameGame, dfvPlay, enableDFVMobile, venueId) => {
        if (!playSequenceInstance) {
            playSequenceInstance = new PlaySequence(dfvPlay);
        }

        if (!isSameGame && playSequenceInstance) {
            playSequenceInstance.reset();
        }

        const playSequenceData = playSequenceInstance.getReplay({ allPlays, currentPlay });

        return {
            ...playSequenceData,
            allPlays,
            enableDFVMobile,
            venueId,
            disable: dfvPlay?.disable,
            gamePk,
            atBatIndex: playSequenceData?.currentPlay.atBatIndex
        };
    }
);
